<template>
    <div>
        <div class="mb-5">
            <div class="border border-primary text-primary rounded p-5">
                <div class="d-flex flex-row">
                    <div class="px-2" style="font-size: 2.2em;">
                        <i class="fas fa-info-circle"/>
                    </div>
                    <div class="flex-grow-1 text-lg pl-3">
                        <div><b>Bilder</b> können z.Z. nur über eine <b>URL</b> im Datensatz geladen werden.<br>Bitte fügen Sie keine
                            Bild-Elemente in
                            Excel-Dateien ein.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h3>Grundeinstellungen</h3>
        <FormGroupNew label="__('form.file')">
            <input ref="flatFile" class="d-block" type="file" name="flat_file" :accept="accept" @input="fileChanged">
            <span class="form-text text-muted">{{ __('form.supported_file_types') }}: {{ list }}</span>
        </FormGroupNew>

        <div v-if="requiresAdditionalInfo" class="mt-3">
            <div class="row">
                <div class="col-xl-4">
                    <FormGroupNew label="Trennzeichen" required>
                        <input class="form-control" type="text" name="delimiter" placeholder="; oder \t für Tabulatoren"
                               required
                               v-model="settings.delimiter"
                               @input="inputChanged"/>
                        <span class="form-text text-muted">Geben Sie das Trennzeichen an, mit dem die Spalten in Ihrer Datei getrennt werden. Üblicherweise Semikolon oder Komma.</span>
                    </FormGroupNew>
                </div>
                <div class="col-xl-4">
                    <FormGroupNew label="Textumschließung">
                        <input class="form-control" type="text" name="enclosure" placeholder="Keine Textumschließung"
                               v-model="settings.enclosure"
                               @input="inputChanged"/>
                        <span class="form-text text-muted">Dieses Feld nur ausfüllen, falls Zeichenketten mit einem bestimmten Zeichen begrenzt sind.</span>
                    </FormGroupNew>
                </div>
                <div class="col-xl-4">
                    <FormGroupNew label="Zeile mit Überschriften">
                        <input class="form-control" type="number" name="header_offset" value="0" min="0"
                               v-model="settings.header_offset"
                               @input="inputChanged"
                               placeholder="Die erste Zeile hat den Index 0"/>
                        <span class="form-text text-muted">Lassen Sie diesen Wert unverändert, falls die Überschriften in der ersten Zeile stehen.</span>
                    </FormGroupNew>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormGroupNew from '@components/Form/FormGroupNew.vue'

export default {
    components: {FormGroupNew},
    data() {
        return {
            selectedMimeType: null,
            canProceedToMapping: false,
            allowedExtensions: ['csv', 'tsv', 'txt', 'json'],
            settings: {
                header_offset: 0,
                delimiter: null,
                enclosure: '',
            },
        }
    },

    methods: {
        fileChanged(e) {
            this.selectedMimeType = e.target.files[0].type
            this.$emit('file', e.target.files[0])
        },

        isExcel(mimeType) {
            return !mimeType.startsWith('text/') //TODO: get excel mime types and check against them
        },

        checkCanProceed() {
            if (this.selectedMimeType === null) {
                return
            }
            if (this.settings.delimiter === null || this.settings.delimiter.length === 0) {
                return
            }
            this.$emit('canProceed', true)
        },

        inputChanged() {
            this.$emit('input', this.settings)
            this.checkCanProceed()
        },
    },

    computed: {
        accept() {
            return '.' + this.allowedExtensions.join(',.')
        },

        list() {
            return this.allowedExtensions.join(', ')
        },

        requiresAdditionalInfo() {
            if (this.selectedMimeType === null) {
                return false
            }

            return !this.isExcel(this.selectedMimeType)
        },
    },

    watch: {
        selectedMimeType() {
            this.checkCanProceed()
        },
    },
}
</script>
